import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { appNamedRoutes } from '../routes';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="row u-navbar-padding">
      <div className="column u-margin-top--large">
        <Link className='o-sp-button o-sp-button--back' to={appNamedRoutes.partnerRoot}>
          <i className='sp-icon-arrow-left'></i>&nbsp;{t('notFound.goToHome')}
        </Link>
        <h1 className='u-margin-top--base'>{t('notFound.pageNotFound')}</h1>
        <p>{t('notFound.permissionMessage')}</p>
      </div>
    </div>
  );
};

export default NotFound;
